import type { SxProps } from '@mui/material'
import { List as MUIList } from '@mui/material'
interface IListProps {
  sx?: SxProps
  children: React.ReactNode
}

export default function List({ sx, children }: IListProps) {
  return <MUIList sx={sx}>{children}</MUIList>
}
